<template>
  <div class="morebarpop">
    <div
      v-if="!isShowPop"
      class="morebarpop__mask"
      @click.stop="$emit('onMask')"
    ></div>
    <ul
      v-if="!isShowPop"
      class="morebarpop__lis"
    >
      <li
        class="morebarpop__li"
        @click.stop="$emit('onSelectTime')"
      >
        <img
          :src="selectIcon"
          alt=""
          srcset=""
        >
        <span class="morebarpop__txt"> 筛选</span>
      </li>
      <li
        class="morebarpop__li"
        @click.stop="$emit('onRefresh')"
      > <img
          :src="refreshIcon"
          alt=""
          srcset=""
        >
        <span class="morebarpop__txt"> 刷新</span>
      </li>
      <li
        class="morebarpop__li"
        @click.stop="showPop"
      > <img
          :src="aboutIcon"
          alt=""
          srcset=""
        >
        <span class="morebarpop__txt"> 版本</span>

      </li>
    </ul>
    <transition name="pop">
      <popover
        v-show="isShowPop"
        :message="'当前版本号:'+this.version"
        position='left'
      ></popover>
    </transition>

  </div>
</template>
<script>
import Popover from './Popover'
import { Dialog } from 'vant'
export default {
  components: { Popover },
  data () {
    return {
      version: 20201210,
      newEdition: '',
      isShowPop: false,
      selectIcon: './Icon/xuan@2x.png',
      refreshIcon: './Icon/refresh.png',
      aboutIcon: './Icon/about.png'
    }
  },
  methods: {
    showPop () {
      if (window.serverVersion && (Number(this.version) !== Number(window.serverVersion))) {
        // if (this.$cookies.get("serverVersion") && (Number(this.version) !== Number(this.$cookies.get("serverVersion")))) {
        Dialog.alert({
          title: '提示',
          message: '您当前使用版本为' + this.version + ',最新版本为' + this.$cookies.get("serverVersion") + ',请重新进入此应用或刷新'
        }).then(() => {
          this.$emit('hidePop')
          // on close
          // dd.biz.navigation.close()
        })
      } else {
        this.isShowPop = true

        setTimeout(() => { this.isShowPop = false; this.$emit('hidePop') }, 3000)
      }
    }
  },
  created () {
    // if (this.version < window.serverVersion) {
    //   this.newEdition = "<span style='color:#F66561;font-size:10px'> 有更新版本</span>"
    // }
  }
}
</script>
<style lang="scss">
.morebarpop {
  position: fixed;
  top: px2rem(70);
  right: px2rem(10);
  background: #02163b;
  // background: #ffffff;
  padding: px2rem(5) 0;
  border-radius: px2rem(10);
  z-index: 999;
  .morebarpop__mask {
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    width: 100vw;
    height: 100vh;
  }
  &:after {
    display: block;
    content: '';
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #02163b;
    right: px2rem(20);
    width: 1px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    top: -5px;
    position: absolute;
  }
  .morebarpop__lis {
    z-index: 1000;
    padding: 0 px2rem(20);
    .morebarpop__li {
      // color:#333333;
      position: relative;
      &:last-child {
        border: none;
      }
      border-bottom: 1px solid #0f3474;
      padding: px2rem(20) px2rem(12);
      .morebarpop__txt {
        color: #aeb8d7;
        display: inline-block;
        padding-left: px2rem(20);
        transform: translateY(-2px);
      }
      img {
        margin: 0 !important;
        width: px2rem(32) !important;
      }
    }
  }
}
.pop-enter,
.pop-leave-to {
  opacity: 0;
}
.pop-leave,
.pop-enter-to {
  opacity: 1;
}
.pop-enter-active,
.pop-leave-active {
  transition: all 0.3s;
}
</style>
